import React, {FC} from 'react';

import {ERequestStatus} from 'store/slices/request-slice/request-slice-type';

import {RequestActionItem} from '../actions/request-action-item';

interface IButtonsProps {
    requestFormKey: string;
    requestCommentId?: string;
    actions?: ERequestStatus[];
    onClose?: () => void;
    onBack?: () => void;
    entityName?: string;
    onSubmit?: () => void;
}

export const Buttons: FC<IButtonsProps> = (
    {
        actions,
        onClose,
        onBack,
        entityName,
        requestFormKey,
        onSubmit,
        requestCommentId,
    }: IButtonsProps,
) => {
    const showButtons = onClose || onBack || actions?.length;
    if (!showButtons) return null;

    const actionsList = actions?.map(
        action => (
            <RequestActionItem
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                key={action}
                action={action}
                entityName={entityName}
                onSubmit={onSubmit}
            />

        ),
    );

    return actionsList?.length ? (
        <>{actionsList}</>
    ) : null;
};
